/* eslint-disable quotes */
export default {
  AWAY_TIME: 's',
  COMMON__MINUTES: 'm',
  SENDBIRD: {
    BADGE__OVER: '+',
    MESSAGE_MENU__EDIT: 'BEARBEITEN',
    BUTTON__DELETE: 'Löschen',
    MESSAGE_STATUS__DELETE: 'Löschen',
    MESSAGE_MENU__DELETE: 'Löschen',
    BUTTON__SAVE: 'Speichern',
    BUTTON__CLOSE: 'Schließen',
    BUTTON__CANCEL: 'Abbrechen',
    CHANNEL_SETTING__PROFILE__EDIT: 'Bearbeiten',
    MESSAGE_INPUT__PLACE_HOLDER: 'Eingabe',
    MODAL__CHANNEL_INFORMATION__UPLOAD: 'Hochladen',
    EDIT_PROFILE__IMAGE_UPLOAD: 'Hochladen',
    CHANNEL_LIST__TITLE: 'Kanal',
    MESSAGE_MENU__COPY: 'Kopie',
    CHANNEL_SETTING__HEADER__TITLE: 'Channel Informationen',
    MODAL__USER_LIST__TITLE: 'Mitglieder',
    CHANNEL_SETTING__MEMBERS__TITLE: 'Mitglieder',
    NO_MEMBERS: '(keine Mitglieder)',
    NO_NAME: '(kein Name)',
    TOOLTIP__UNKOWN_USER: '(kein Name)',
    CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: 'Channel verlassen',
    BUTTON__INVITE: 'einladen',
    MODAL__INVITE_MEMBER__SELECTED: 'Ausgewählt',
    MODAL__CREATE_CHANNEL__SELECTED: 'Ausgewählt',
    MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: 'Channel Name',
    MODAL__INVITE_MEMBER__TITLE: 'Mitglieder einladen',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER: 'Eingabe',
    BUTTON__CREATE: 'Erstellen',
    MODAL__CREATE_CHANNEL__TITLE: 'Neuer Channel',
    TRYING_TO_CONNECT: 'Versuche zu verbinden...',
    USER_PROFILE__MESSAGE: 'Nachricht',
    USER_PROFILE__USER_ID: 'Benutzer ID',
    EDIT_PROFILE__USERID_LABEL: 'Benutzer ID',
    EDIT_PROFILE__TITLE: 'Mein Profil',
    EDIT_PROFILE__IMAGE_LABEL: 'Profilbild',
    EDIT_PROFILE__NICKNAME_LABEL: 'Spitzname',
    EDIT_PROFILE__THEME_LABEL: 'Dunkle Oberfläche',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER__DISABLED: 'Chat ist in diesem Channel nicht verfügbar',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: 'Neue Nachricht(en) seit',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: 'auf / an',
    CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: 'Alle Mitglieder',
    CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: 'Anwender einladen',
    MODAL__DELETE_MESSAGE__TITLE: 'Diese Nachricht löschen?',
    MODAL__CHANNEL_INFORMATION__TITLE: 'Channel Informationen bearbeiten',
    MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: 'Channel Bild',
    MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: 'Namen eingeben',
    TYPING_INDICATOR__IS_TYPING: 'tippen...',
    TYPING_INDICATOR__ARE_TYPING: 'tippen...',
    TYPING_INDICATOR__MULTIPLE_TYPING: 'tippen...',
    TYPING_INDICATOR__AND: 'und',
    MESSAGE_STATUS__SENDING_FAILED: 'Konnte Nachricht nicht senden',
    MESSAGE_STATUS__TRY_AGAIN: 'Erneut versuchen',
    MESSAGE_STATUS__OR: 'oder',
    PLACE_HOLDER__WRONG: 'Etwas hat nicht funktioniert',
    PLACE_HOLDER__RETRY_TO_CONNECT: 'Wiederholen',
    NO_TITLE: 'Kein Titel',
    TOOLTIP__AND_YOU: ', und Sie',
    TOOLTIP__YOU: 'Sie',
    UNKNOWN__UNKNOWN_MESSAGE_TYPE: '(unbekannter Nachrichtentyp)',
    UNKNOWN__CANNOT_READ_MESSAGE: 'kann diese Nachricht nicht lesen.',
    MESSAGE_EDITED: '(bearbeitet)',
    PLACE_HOLDER__NO_CHANNEL: 'Starten Sie ein neues Gespräch',
    MESSAGE_MENU__REPLY: 'Antworten',
    QUOTED_MESSAGE__REPLIED_TO: '→',
    QUOTE_MESSAGE_INPUT__REPLY_TO: '',
    QUOTED_MESSAGE__CURRENT_USER: 'Sie',
    MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: 'Auf eine Nachricht antworten',
  },
  TERMS_IMPRESSUM: 'Impressum',
  TERMS_DATENSCHUTZ: 'Datenschutz',
  CONFIRM: 'OK',
  SETTINGS__NONE: 'Keiner',
  SEARCH__NO_RESULT: 'Es gibt kein Suchergebnis',
  LOGIN__PASSWORD: 'Kennwort',
  SEARCH__USER_PLACEHOLDER: 'Name/Arbeitnehmer-Nr./Registrierungsnummer',
  BASIC__: {
    HAS_ATTENDANCE_HISTORY_VIEW_RIGHT: 'Autorisiert, die persönliche Stechhistorie einzusehen?',
    ERROR: 'Ein Fehler ist aufgetreten. <br /> Bitte versuchen Sie es später noch einmal.',
    MSG__: { INPUT: 'Suche nach Schlüsselwort' },
    PWD_ALL_VALIDATION:
      'Das Passwort muss aus einer Kombination von %1$@~%2$@ Buchstaben in Groß- und Kleinschreibung, Zahlen und Sonderzeichen bestehen.',
    RETRY: 'wiederholen',
    PASSWORD_RULE: '8-20 Zeichen und enthalten Buchstaben, Zahlen und Symbole.',
  },
  SEARCH__NO_USER_INFO: 'Es gibt keine Benutzerinformationen.',
  LOGIN__EMAIL_OR_HP: 'E-Mail/Registrierungsnummer',
  BASIC__SEARCH: 'Suche',
  ELECTRON: {
    MENU_DELETE: 'Löschen',
    MENU_VIEW: 'Ansicht',
    MENU_SIGN_OUT: 'Abmeldung',
    MENU_SETTINGS: 'Einstellungen',
    MENU_CLOSE: 'Schließen',
    MENU_EDIT: 'Bearbeiten',
    MENU_SELECT_ALL: 'Alle auswählen',
    MENU_COPY: 'Kopie',
    MENU_FILE: 'Dateien',
    MENU_ABOUT: 'Über {0}',
    MENU_UPDATE: 'Update prüfen',
    MENU_HIDE: 'Verstecken {0}',
    MENU_HIDE_OTHERS: 'Andere verstecken',
    MENU_SHOW_ALL: 'Alle anzeigen',
    MENU_QUIT: 'Beenden {0}',
    MENU_NEW_CHANNEL: 'Neuer Channel',
    MENU_UNDO: 'Rückgängig',
    MENU_REDO: 'Wiederholen',
    MENU_CUT: 'Ab/schneiden',
    MENU_PASTE: 'Einfügen',
    MENU_PASTE_AND_MATCH_STYLE: 'Stil einfügen',
    MENU_RELOAD: 'Nachladen',
    MENU_FORCE_RELOAD: 'Nachladen erzwingen',
    MENU_FULL_SCREEN: 'Auf Vollbild umschalten',
    MENU_RESET_ZOOM: 'Tatsächliche Größe',
    MENU_ZOOM_IN: 'Rein zoomen',
    MENU_ZOOM_OUT: 'Raus zoomen',
    MENU_WINDOW: 'Fenster',
    MENU_MINIMIZE: 'Minimieren',
    MENU_ZOOM: 'Zoomen',
    MENU_HELP: 'Hilfe',
    MESSAGE_UP_TO_DATE: 'Sie verwenden derzeit die aktuelle Version.',
    UPDATE_AVAILABLE: 'Update verfügbar',
    MESSAGE_UPDATE_AVAILABLE: 'Ein Update der aktuellen Version ist verfügbar.',
    UP_TO_DATE: 'Neueste Version',
  },
  LOGIN__INSERT_EMAIL_HP: 'E-Mail oder Registrierungsnummer eingeben.',
  LOGIN__PASSWORD_GUIDE_SUBTITLE:
    'Wenn Sie Ihr Passwort vergessen haben, setzen Sie es bitte auf der Login-Seite der mobilen App zurück.',
  LOGIN__INSERT_PASSWORD: 'Bitte Passwort eingeben',
  LOGIN__PASSWORD_INFORMATION: 'Haben Sie Ihr Passwort vergessen?',
  BEFORE: 'Vorher',
  ALERT__NO_ONE_SELECTED: 'Kein Personal ausgewählt.',
  LOGOUT: 'Abmeldung',
  LOGIN: 'Anmelden',
  COMMON__SECONDS: 'Sekunde(n)',
  SCHEDULE__: {
    GUIDE__: {
      IF_YOU_STOP_UNSAVED: 'Wenn Sie die Bearbeitung abbrechen, werden die Änderungen nicht gespeichert.',
      ARE_YOU_SURE_WANT_TO_STOP: 'Sind Sie sicher, dass Sie die Bearbeitung des Zeitplans abbrechen wollen?',
    },
  },
  TEMPLATE__: {
    GUIDE__: { NO_TEMPLATE_REGISTERED: 'Keine Vorlage registriert' },
  },
  SETTINGS__CHANGE_LANGUAGE: 'Sprache',
  SEARCH__MEMBER_PLACEHOLDER: 'Name/Arbeitnehmer-Nr./Registrierungsnummer',
  MSG__: {
    BASIC__: { NO_SEARCH_RESULT: 'Es gibt kein Ergebnis.' },
    ERROR__: {
      CREATE_CHANNEL: 'Konnte Channel nicht erstellen.',
      UPDATE_CHANNEL_INFO: 'Konnte Channel nicht aktualisieren.',
      LEAVE_CHANNEL: 'Konnte Channel nicht verlassen.',
    },
    FILE__: { MAXIMGSIZE: 'Dateigrößenlimit überschritten.' },
    ALLOW_BROWSER_ALARM:
      'Erlauben Sie Benachrichtigungen in Ihren Browsereinstellungen, um Benachrichtigungen zu erhalten.',
    LABEL__: { SEARCH_MESSAGE: 'Nachrichten suchen' },
    GUIDE__: {
      SEARCH_MESSAGE: 'Suchen Sie in {0} nach der gewünschten Nachricht.',
    },
  },
  BASIC__UNKNOWN: 'unbekannt',
  LOGIN__SERVER_ALERT: 'keine Verbindung zum Server.',
  INVITE__MEMBER_SELECTION: 'Wähle Mitglieder aus',
  CHANNEL__EDIT_CHANNEL_NAME_GUIDE: 'Der geänderte Name wird für alle Channel Teilnehmer sichtbar sein.',
  NOTICE: 'Benachrichtigungen',
  INVITE__CREATE: 'Erstellen',
  CHANNEL__LEAVE_THIS_CHANNEL: 'Channel verlassen?',
  LOGIN__PASSWORD_FAIL_COUNT: 'Sie haben das falsche Passwort {0} Mal falsch eingegeben.',
  LOGIN__FAIL_ALERT: 'Es wird für 5 Minuten gesperrt nach 5 aufeinanderfolgenden Falschversuchen.',
  LOGIN__LOCK_STATE_ALERT: 'Für 5 Minuten gesperrt aufgrund aufeinanderfolgenden Falschversuchen.',
  LOGIN__RETRY_ALERT: 'Bitte Versuchen Sie es in {0} Minuten erneut.',
  LOGIN__PASSWORD_GUIDE_TITLE: "ShoplChat's Passwort ist das Selbe wie in der mobilen App.",
  SETTINGS__ALL_MESSAGES: 'Benachrichtigung bei allen neuen Nachrichten',
  SETTINGS__ALARM_SOUND: 'Klang / Ton',
  SETTINGS__SOUND_ALARM: 'Benachrichtigungston',
  SETTINGS__LISTEN_ALARM_SOUND: 'Hören',
  ALERT__MAX_INVITE_MEMBER: 'Die maximale Anzahl an Menschen die dem Channel beitreten können ist 20.000.',
  LOGIN__DEACTIVATED_ALERT: 'Anmelden nicht möglich, da der Administrator die Chat Funktion deaktiviert hat,',
  LOGIN__SERVER_ALERT_CONTENTS:
    'Anmeldung nicht möglich aufgrund instabilen Netzwerks. Bitte überprüfen Sie die Netzwerkverbindung und versuchen es nochmal.',
  LOGIN__LOGOUT_ALERT: 'Sie wurden abgemeldet.',
  CHANNEL__EDIT_CHANNEL_NAME: 'Channel Namen ändern',
  SETTINGS__THEME: 'Thema',
  SETTINGS__LANGUAGE: 'Sprache',
  SETTINGS__LIGHT_THEME: 'Licht',
  SETTINGS__DARK_THEME: 'Dunkel',
  SEARCH__CHANNEL_PLACEHOLDER: 'Mitarbeitername',
  CHANNEL__CONTACT: '1:1 Unterhaltung',
  BASIC: {
    LABEL: { MAXIMAGECNT: 'Bis zu {0} Bilder können registriert werden.' },
  },
  LOGIN__LOGIN_FAILED: 'ID oder Passwort ist falsch.',
  FORGOT_PW: 'Haben Sie Ihr Passwort vergessen?',
  BASIC__MAX_FORMAT_INPUT: 'max. %@ Zeichen können eingegeben werden.',
  SERVICE__COMING_SOON: 'Coming soon',
  LOGIN__GUIDE: 'Sie können sich mit dem in der App verwendeten Konto anmelden.',
  MOBILE__: {
    ACCESS_PC: 'Greifen Sie vom PC aus auf das Dashboard zu!',
    ACCESS_DESC_01: 'Dashboard ist für die PC-Umgebung optimiert.',
    ACCESS_DESC_02: 'Probieren Sie den Zugriff von einem PC aus, um die beste Erfahrung zu erzielen.',
    ACCESS_PC_ONLY: 'Versuchen Sie den Zugriff vom PC!',
    GUIDE: 'Die Chat-Funktion ist auf Ihrem PC oder Ihrer mobilen App verfügbar.',
  },
  CHANNEL__NO_CHAT_HISTORY: 'Keine Gespräche',
};
